<script lang="ts">
	import {
		chain,
		smartWalletCreationPending,
		walletConnected,
		walletLoaded
	} from '$lib/wallet/store';
	import { checkingSmartContractWallet } from './store';
	import { smartContractWalletAddress } from './store';
	import ConnectWalletButton from '$lib/util/ConnectWalletButton.svelte';
	import CreateScWalletButton from '$lib/util/CreateSCWalletButton.svelte';
	import SwitchToOptimismButton from '$lib/util/SwitchToOptimismButton.svelte';
	import TopSectionWallet from './TopSectionWallet.svelte';
	import SCDepositWithdraw from './depositwithdraw/SCDepositWithdraw.svelte';
	import ScOtherDetails from './otherdetails/SCOtherDetails.svelte';
	import Wallet from '$lib/wallet/Wallet.svelte';
	import ScMarkets from './markets/SCMarkets.svelte';
	import CreateScWalletButtonWithInfo from '$lib/util/CreateSCWalletButtonWithInfo.svelte';
	import { isSupportedNetwork } from '$lib/util/util';
</script>

{#if $walletLoaded && $walletConnected && isSupportedNetwork($chain?.id) && $smartContractWalletAddress}
	<div class="sm:overflow-y-auto sm:mx-2 relative no-scrollbar">
		<TopSectionWallet />
		<ScOtherDetails />

		<div class="my-2 w-fit mx-auto block sm:hidden">
			<Wallet />
		</div>

		<SCDepositWithdraw />

		<ScMarkets />

		<div class="border-t border-fx-grey-800 my-5" />
	</div>
{:else if $walletLoaded && !$walletConnected}
	<div class="w-full flex-col items-center justify-center">
		<div class="text-center text-fx-grey-300 text-sm mb-4">Please connect wallet to use Perps</div>
		<ConnectWalletButton />
	</div>
{:else if $smartWalletCreationPending}
	<CreateScWalletButtonWithInfo source="SC Wallet" />
{:else if $walletLoaded && $walletConnected && !isSupportedNetwork($chain?.id)}
	<div class="w-full flex-col items-center justify-center">
		<div class="text-center text-fx-grey-300 text-sm mb-4">Please switch network to Optimism</div>
		<SwitchToOptimismButton />
	</div>
{:else if $walletLoaded && $walletConnected && isSupportedNetwork($chain?.id) && !$smartContractWalletAddress && $checkingSmartContractWallet == false}
	<div class="w-full flex-col items-center justify-center">
		<div class="text-center text-fx-grey-300 text-sm mb-4">
			{$checkingSmartContractWallet}
			{$smartContractWalletAddress}

			Create Polynomial Wallet to use perps. Polynomial Wallet is a smart contract wallet which
			enables you to do a lot more than a usual wallet. All transactions will be made by the Smart
			Contract wallet and you just need to deposit funds in it. You can withdraw your funds anytime
			without any restrictions or service fees.
		</div>
		<CreateScWalletButton source="SC Wallet" />
	</div>
{:else}
	<div class="px-10 grid gap-4">
		<div
			class="w-full h-40 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>
		<div
			class="w-full h-20 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>

		<div
			class="w-full h-20 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>
		<div
			class="w-full h-30 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>
		<div
			class="w-full h-10 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>
		<div
			class="w-full h-20 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl"
		/>
	</div>
{/if}
